// Vue

// Dependencies
import { defineStore } from "pinia";

// Utils

// Types
import { ThemeConfigType, ThemeType, ThemeStyleType } from "../types/ThemeConfigType";

interface ThemeProvider {
  get: ({ config, theme, state }: { config: ThemeConfigType; theme: keyof ThemeConfigType; state?: string }) => ThemeStyleType;
}

const useTheme = defineStore("ThemeProvider", (): ThemeProvider => {
  // ///////////////////
  // Methods
  // ///////////////////

  function get({
    config,
    theme,
    state,
  }: {
    config: ThemeConfigType;
    theme: keyof ThemeConfigType;
    state?: string;
  }): ThemeStyleType {
    const typedState = state as keyof ThemeType;
    return config?.[theme]?.[typedState || "passive"] ?? ({} as ThemeStyleType);
  }

  // ///////////////////
  // Return
  // ///////////////////

  return {
    get,
  };
});

export default useTheme;
